import {
  Conditional,
  RequestServiceStepIndicator
} from '@cat-ecom/pcc-components';
import Descriptionwrapper from '../description-wrapper/description-wrapper';

const RequestEquipmentServiceDescription = ({ isMobile, classname }) => {
  return (
    <>
      <Descriptionwrapper />
      <Conditional test={isMobile}>
        <div className="pt-3">
          <RequestServiceStepIndicator classname={classname} />
        </div>
      </Conditional>
    </>
  );
};
export default RequestEquipmentServiceDescription;
